<template>
  <div class="empty" :style="wrapStyle">
    <div>
      <van-icon name="info" size="40" color="#979797" />
    </div>
    <p>暂无数据</p>
  </div>
</template>

<script>
export default {
  name: 'empty',
  props: {
    height: {
      type: Number,
      default: 100
    }
  },
  computed: {
    wrapStyle() {
      return {
        height: this.height + 'vh'
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.empty
  height 100vh
  display flex
  flex-direction column
  align-items center
  justify-content center
  color #979797
  p
    margin-top 1rem
    font-size 14px
</style>